import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { setCurrentPage } from "../../lib/redux/slices/contractPaginateSlice";

const useDebounce = (value, delay, shouldResetPage = false) => {
  const dispatch = useDispatch();
  const [debouncedValue, setDebouncedValue] = useState(value);
  const prevValueRef = useRef(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);

      const hasActuallyChanged = prevValueRef.current !== value;

      if (shouldResetPage && hasActuallyChanged) {
        dispatch(setCurrentPage(1));
      }

      prevValueRef.current = value;
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay, shouldResetPage, dispatch]);

  return debouncedValue;
};

export default useDebounce;
